import { render, staticRenderFns } from "./xxDialog.vue?vue&type=template&id=3c09df7f&scoped=true"
import script from "./xxDialog.vue?vue&type=script&lang=js"
export * from "./xxDialog.vue?vue&type=script&lang=js"
import style0 from "./xxDialog.vue?vue&type=style&index=0&id=3c09df7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c09df7f",
  null
  
)

export default component.exports